import { useEffect } from "react";
import useLatest from "./useLatest";

export default function useOutsideClick(
  elementRef,
  handler,
  attached = true,
  exceptions = []
) {
  const latestHandler = useLatest(handler);

  useEffect(() => {
    if (!attached) return;

    const handleClick = (e) => {
      if (!elementRef.current) return;

      const inException = exceptions
        .filter((item) => !!item)
        .reduce((acc, item) => {
          if (acc) return acc;
          return item.current?.contains(e.target);
        }, false);

      if (inException) return;

      if (!elementRef.current.contains(e.target)) {
        latestHandler.current();
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [elementRef, latestHandler, attached, exceptions]);
}
